import { useMemo } from "react";
import LeaderboardTopFive from "./table/LeaderboardTopFive";
import LeaderboardTable from "./table/LeaderboardTable";
import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { getWinRateColor } from "@ugg/shared/utils/win-rates";
import { getProfileOverviewUrl } from "@ugg/shared/routes/app-routes";
import { LeaderboardData } from "@ugg/shared/api/requests/leaderboards/leaderboard-page";
import { LeaderboardPlayerPlus } from "@ugg/shared/interfaces/leaderboards.interface";
import { OTPStats, OTPStats2 } from "@ugg/shared/api/requests/champions/otp";
import { RegionS } from "@ugg/shared/utils/region-helpers";

interface ChampionLeaderboardTableContainerProps {
  page: number;
  data: Array<(OTPStats | OTPStats2) & { overallRanking: number }>;
  championId: number;
  showRegion?: boolean;
}

const ChampionLeaderboardTableContainer = (props: ChampionLeaderboardTableContainerProps) => {
  const { page, data, championId, showRegion } = props;
  const queryParams = useQueryString();
  const { region } = queryParams;

  const tableData: {
    topFive: LeaderboardPlayerPlus[];
    remainingData: LeaderboardPlayerPlus[];
    firstEntryRanking: number;
    lastEntryRanking: number;
  } = useMemo(() => {
    const currentData = data.map((player) => {
      const { winRate, gamesPlayed, regionId } = player || {};
      const wins = Math.round(winRate * gamesPlayed);
      const losses = gamesPlayed - wins;
      const roundedWinRate = Math.round(winRate * 100);
      const winRateColor =
        getWinRateColor(roundedWinRate).toLowerCase() === "#ffffff" ? "#cddcfe" : getWinRateColor(roundedWinRate);
      const profileURL = getProfileOverviewUrl(
        region && region !== RegionS.WORLD ? region : regionId,
        player.riotUserName,
        player.riotTagLine,
      );

      return {
        ...player,
        summonerLevel: 0,
        profileURL,
        totalGamesPlayed: gamesPlayed,
        winRate: roundedWinRate,
        wins: String(wins), // workaround for backend bug
        losses: String(losses), // workaround for backend bug
        winRateColor,
      };
    });

    const topFive = page === 1 ? currentData.slice(0, 5) : [];
    const remainingData = page === 1 ? currentData.slice(5) : currentData;
    const firstEntryRanking = (remainingData[0] && remainingData[0].overallRanking) || 0;
    const lastEntryRanking =
      (remainingData[remainingData.length - 1] && remainingData[remainingData.length - 1].overallRanking) || 0;

    // console.log(topFive, remainingData, firstEntryRanking, lastEntryRanking);
    return { topFive, remainingData, firstEntryRanking, lastEntryRanking };
  }, [page, data]);

  return (
    <div className="leaderboard_table-container">
      {page === 1 && tableData.topFive.length === 5 && (
        <LeaderboardTopFive data={tableData.topFive} topPlayerMostPlayedChamp={championId} showRegion={showRegion} />
      )}
      <LeaderboardTable
        page={page}
        totalCount={data.length}
        tableData={tableData}
        hidePagination={true}
        showRegion={showRegion}
      />
    </div>
  );
};

export default ChampionLeaderboardTableContainer;
